import React, { Component, useEffect,useState } from 'react'
import RequestHandler from "util/RequestHandler";
import moment from "moment";
import { ColumnHelper } from "util/TableHelper";

import { Table, Empty, Col, Row, Tooltip } from "antd";



const AccountTransactionTable = (props) => {
    
  
    const [tableData, setTableData] = useState({
        data: [],
        total: 0,
        loading: true,
      });
      const [tableDataQueryOptions, setTableDataQueryOptions] = useState({
        skip: 0,
        take: 5,
        current: 1,
        filter: "",
      });
    
      useEffect(() => getTableData(), [tableDataQueryOptions]);
      
      const getFilterQuery = () => {
        const { filter } = tableDataQueryOptions;
    
        const conditions = [];
        let query = "";
    
        if (filter) {
          conditions.push(filter);
        }
    
        if (conditions.length !== 0) {
          query = "$filter=" + conditions.join(" and ");
        }
        return query;
      };
    
      const getTableData = () => {
        setTableData({
          ...tableData,
          loading: true,
        });
    
        const { skip, take } = tableDataQueryOptions;
    
        RequestHandler.get(
            `/ToslaAccountTransaction?$count=true&${getFilterQuery()}&$skip=${skip}&$top=${take}`
          ).then((response) => {
            setTableData({
              data: response.value,
              total: response["@odata.count"],
              loading: false,
            });
          });
      };
    
      const paging = (p) => {
        setTableDataQueryOptions((prevState) => {
          return {
            ...prevState,
            skip: (p.current - 1) * prevState.take,
            take: p.pageSize,
            current: p.current,
          };
        });
      };
    
      const tableColumns = [
          {
            title: "Firma İşlem Id",
            align: "center",
            dataIndex: "orderId",
          },
          {
            title: "İşlem Id",
            align: "center",
            dataIndex: "transactionId",
          },
          {
            title: "İşlem Tarihi",
            dataIndex: "transactionDate",
            align: "center",
            render: (data, row, index) => moment(data).format("DD.MM.YYYY"),
          },
          {
              title: "Tutar",
              dataIndex: "amount",
              align:"center",
              render: (data, row, index) => <p ><>{data.toLocaleString("tr-TR", {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              })}</></p>,
            },
            {
              title: "Durum",
              dataIndex: "status",
              align:"center",
              render: (data,row,index) => {
                if(data === "Success"){
                  return <div style={{color:'#07af2b'}}>Success</div>
                }else if(data === "Failed"){
                  return <div style={{color:'darkred'}}>Failed</div>
                }else if(data === "Retry"){
                  return <div style={{color:'#ffa90a'}}>Retry</div>
                }else if(data === "Reversed"){
                  return <div style={{color:'#08b4db'}}>Reversed</div>
                }
              }
            },
      ];
        return (
            <>
        <Row id="tableArea">
            <Col span={24}>
            <Table
                columns={tableColumns.filter((column) => !column.isRowDetail)}
                locale={{
                emptyText: (
                    <Empty
                    image={Empty.PRESENTED_IMAGE_SIMPLE}
                    description="Veri Yok"
                    />
                ),
                }}
                style={{
                overflowX: "auto",
                maxHeight: "100%",
                width: "100%",
                }}
                rowKey="id"
                filterable={true}
                sortable={true}
                onChange={paging}
                pagination={false}
                dataSource={tableData.data}
                loading={tableData.loading}
                size="small"
               
            />
            </Col>
        </Row>
            </>
        )
}
export default AccountTransactionTable